module.exports = __webpack_public_path__ + "img/sauvara-logo.656d54e9.svg";